import { ref, onMounted, onUnmounted } from "vue"
import PullToRefresh from "pulltorefreshjs"

export function usePullToRefresh(options = {}) {
    const ptrInstance = ref<any>(null)
    const isIOS = ref(/iPad|iPhone|iPod/.test(navigator.userAgent))
    const isTouchingToast = ref(false)
    let touchStartHandler: ((e: TouchEvent) => void) | null = null
    let touchEndHandler: (() => void) | null = null

    const init = (customOptions = {}) => {
        if (!isIOS.value) {
            return
        }

        const isPWA =
            window.matchMedia("(display-mode: standalone)").matches ||
            (window.navigator as any).standalone === true

        if (!isPWA) {
            return
        }

        touchStartHandler = (e: TouchEvent) => {
            let target = e.target as HTMLElement
            while (target && target !== document.body) {
                if (
                    target.classList?.contains("toast-wrapper") ||
                    target.classList?.contains("toast-container") ||
                    target.classList?.contains("toast-msg") ||
                    target.classList?.contains("toast-clear-all")
                ) {
                    isTouchingToast.value = true
                    return
                }
                target = target.parentElement as HTMLElement
            }
            isTouchingToast.value = false
        }

        touchEndHandler = () => {
            isTouchingToast.value = false
        }

        document.addEventListener("touchstart", touchStartHandler, { passive: true })
        document.addEventListener("touchend", touchEndHandler, { passive: true })

        const finalOptions = {
            distThreshold: 60,
            distMax: 80,
            distReload: 50,
            shouldPullToRefresh: () => {
                if (isTouchingToast.value) {
                    return false
                }

                const scrollElement = document.querySelector(".inner-content")
                return scrollElement ? scrollElement.scrollTop === 0 : false
            },
            onRefresh: () => {
                return new Promise<void>((resolve) => {
                    setTimeout(() => {
                        window.location.reload()
                        resolve()
                    }, 1000)
                })
            },
            ...options,
            ...customOptions,
        }

        ptrInstance.value = PullToRefresh.init(finalOptions)
    }

    const destroy = () => {
        if (touchStartHandler) {
            document.removeEventListener("touchstart", touchStartHandler)
            touchStartHandler = null
        }
        if (touchEndHandler) {
            document.removeEventListener("touchend", touchEndHandler)
            touchEndHandler = null
        }
        if (ptrInstance.value) {
            PullToRefresh.destroyAll()
            ptrInstance.value = null
        }
    }

    onMounted(() => {
        init()
    })

    onUnmounted(() => {
        destroy()
    })

    return {
        ptrInstance,
        isIOS,
        init,
        destroy,
    }
}
